import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import EducationModuleManager from '../../components/EducationModuleManager';

export default function AdminEducation() {
  const [educationModules, setEducationModules] = useState([]);
  const [loadingEducation, setLoadingEducation] = useState(true);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchEducationModules();
    fetchStats();
  }, []);

const fetchEducationModules = async () => {
  setLoadingEducation(true);
  try {
    const token = localStorage.getItem('token');
    const res = await fetch('/api/education-modules', {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (res.ok) {
      const data = await res.json();
      setEducationModules(data);
    }
  } catch (err) {
    console.error('Failed to fetch education modules:', err);
  } finally {
    setLoadingEducation(false);
  }
};

  const fetchStats = async () => {
    try {
      const res = await fetch('/api/admin/stats', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json();
      setStats(data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold">📚 Education Management</h1>
          <p className="text-gray-600 mt-1">
            Create and manage platform-wide education modules
          </p>
        </div>
        <div className="flex gap-2">
          <Link 
            to="/admin" 
            className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
          >
            ← Back to Dashboard
          </Link>
        </div>
      </div>

      {/* Stats Summary */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow p-4">
          <div className="text-sm text-gray-500">Total Modules</div>
          <div className="text-2xl font-bold">{educationModules.length}</div>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <div className="text-sm text-gray-500">Masters</div>
          <div className="text-2xl font-bold">
            {educationModules.filter(m => m.type === 'master').length}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <div className="text-sm text-gray-500">Clones</div>
          <div className="text-2xl font-bold">
            {educationModules.filter(m => m.type === 'clone').length}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <div className="text-sm text-gray-500">Total Completions</div>
          <div className="text-2xl font-bold">
            {educationModules.reduce((sum, m) => sum + (m.completions || 0), 0)}
          </div>
        </div>
      </div>

      {/* Main Education Manager */}
      <EducationModuleManager 
        role="admin"
        modules={educationModules}
        onRefresh={fetchEducationModules}
        loading={loadingEducation}
      />
    </div>
  );
}
